export default __webpack_public_path__ + "static/media/sharjah.6fd850d1.jpg";